import React from "react";

export default ({ value = "", opts = {} }) => (
  <span className="TUI-String">{value}{opts ? opts.suffix || "" : ""}</span>
);
